import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageNotFound from './Pages/PageNotFound';

import './api';

/* LAYOUT */
import Header from "./Components/Header";
import Footer from "./Components/Footer";

/* PAGES */
import Home from "./Pages/Home";
import Read from "./Pages/Read";
import Cont from "./Pages/Cont";
import Pastor from "./Pages/Pastor";
import WhoWeAre from "./Pages/WhoWeAre";
import PastorMessage from "./Pages/PastorMessage";
import PastorMessageDetail from "./Pages/PastorMessageDetail";
import View from "./Pages/View";
import Contact from "./Pages/Contact";
import Ministry from "./Pages/Ministry";
import MinistryArticle from "./Pages/MinistryArticleDetail";
import ChurchServices from "./Pages/ChurchServices";
import Events from "./Pages/Events";
import Testimonials from "./Pages/Testimonials";
import Gallery from "./Pages/Gallery";
import Join from "./Pages/Join";
import Fellowship from "./Pages/Fellowship";
import Meeting from "./Pages/Meeting";
import BlogList from "./Pages/BlogList";
import BlogDetail from "./Pages/BlogDetails";

function App() {
  return (
    <Router>
      {/* HEADER APPEARS ON ALL PAGES */}
      <Header />

      {/* MAIN CONTENT */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/read" element={<Read />} />
        <Route path="/cont" element={<Cont />} />
        <Route path="/pastor" element={<Pastor />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/pastor-messages" element={<PastorMessage />} />
        <Route path="/pastor-messages/:slug" element={<PastorMessageDetail />} />
        <Route path="/view" element={<View />} />
        <Route path="/ministry" element={<Ministry />} />
        <Route path="/ministry/:slug" element={<MinistryArticle />} />
        <Route path="/church-services" element={<ChurchServices />} />
        <Route path="/events" element={<Events />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/join" element={<Join />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<BlogList />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/fellowship" element={<Fellowship/>} />
        <Route path="/meeting" element={<Meeting />} />

        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {/* FOOTER APPEARS ON ALL PAGES */}
      <Footer />
    </Router>
  );
}

export default App;

